import React, {useState} from 'react';
import {Layout, Spin} from 'antd';

import {VideoInstruction} from 'components/VideoInstructions';
import {VideoInstructionInterface} from 'components/VideoInstructions/types';

import InstructionCard from './InstructionCard';
import {PositionOptions} from './useVideoInstructions';

const {Content} = Layout;

interface InstructionsTabProps {
    instructions: VideoInstructionInterface[];
    loading: boolean;
    positions?: PositionOptions;
    reload: (position?: number) => void;
}

const InstructionsTab: React.FC<InstructionsTabProps> = ({instructions, loading, positions, reload}) => {
    const [showVideoModal, setShowVideoModal] = useState(false);
    const [videoInstructionCode, setVideoInstructionCode] = useState<string>();
    const [videoInstructionId, setVideoInstructionId] = useState<number>();

    const openVideo = (instruction: VideoInstructionInterface) => {
        setVideoInstructionCode(instruction.videoCode);
        setVideoInstructionId(instruction.id);
        setShowVideoModal(true);
    };

    return (
        <>
            <hr className='form-group-separator'/>
            <Spin style={{marginTop: 20}} spinning={loading}>
                <Content className='instructions-content'>
                    {instructions.map((instruction) => (
                        <InstructionCard key={instruction.id} instruction={instruction} onOpen={openVideo}/>
                    ))}
                </Content>
            </Spin>

            <VideoInstruction
                visible={showVideoModal}
                onCancel={() => setShowVideoModal(false)}
                videoCode={videoInstructionCode}
                id={videoInstructionId}
                reset={false}
                positions={positions}
                reloadInstructions={reload}
            />
        </>
    );
};

export default InstructionsTab;
